<block-ui></block-ui>
  <!-- Page Content -->
  <div class="container-fluid">

    <div *ngIf="ShowPageContent">
      <!-- begin::Header -->
      <div class="card card-custom-h">
        <div class="card-header border-0 pt-5">
          <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
            <form [formGroup]="ConfigurationForm">
              <BBSF-TextBox [options]="searchTextBox" [group]="ConfigurationForm"></BBSF-TextBox>
            </form>
          </div>
          <div class="card-toolbar">
            <!-- begin::Menu -->
            <button type="button" class="btn btn-sm btn-primary" title="Add" (click)="showAddConfigurationModal(AddConfigurationModal)">
              <i class="fas fa-plus me-1"></i>
              {{utilityService.getResourceValue("Add")}}
            </button>
            <!-- end::Menu -->
          </div>
        </div>
        <!-- end::Header -->
        <!-- begin::Body -->
        <div class="card-body py-3">
          <!-- begin::Table container -->
          <div class="table-responsive">
            <!-- begin::Table -->
            <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
              <thead>
                <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                  <th class="min-w-150px">{{utilityService.getResourceValue("Key")}}</th>
                  <th class="min-w-150px">{{utilityService.getResourceValue("Value")}}</th>
                  <th class="min-w-150px">{{utilityService.getResourceValue("Type")}}</th>
                  <th class="min-w-150px">{{utilityService.getResourceValue("Scope")}}</th>
                  <th class="min-w-150px">{{utilityService.getResourceValue("UserPermissionSet")}}</th>
                  <th class="min-w-50px">{{utilityService.getResourceValue("Action")}}</th>
                </tr>
              </thead>
              <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
                <tr *ngFor="let Configuration of ConfigurationPagingResult">

                  <td class="text-dark">{{Configuration.key}}</td>
                  <td>{{Configuration.value}}</td>
                  <td *ngIf="language=='ar'"> {{Configuration.valueTypeName.arabic}}</td>
                  <td *ngIf="language=='en'"> {{Configuration.valueTypeName.english}}</td>
                  <td>{{Configuration.scopeName}}</td>
                  <td>{{Configuration.permissionSetName}}</td>
                  <td>
                    <div>
                      <button mat-button [matMenuTriggerFor]="config" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                        <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                      </button>
                      <mat-menu #config="matMenu">
                        <button class="drop-item px-3" ngbDropdownItem
                                (click)="showEditConfigurationModal(Configuration.id,Configuration.idEncrypted, EditConfigurationModal)">
                          <span class="drop-link px-3">{{utilityService.getResourceValue("Edit")}}</span>
                        </button>
                        <button ngbDropdownItem class="drop-item px-3" id="btnResetPass"
                                (click)="showDeleteConfigurationModal(Configuration, deleteConfigurationModal)">
                          <span class="drop-link px-3">{{utilityService.getResourceValue("Delete")}}</span>
                        </button>
                      </mat-menu>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="ConfigurationPagingResult.length == 0">
                  <td colspan="6">
                    <lib-empty-data></lib-empty-data>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- end::Table -->
          </div>
          <!-- end::Table container -->

        </div>
        <!-- begin paging-->
        <div class="card-footer border-0">
          <BBSF-Paging (Items)="setConfigurationListResult($event)" *ngIf="IsFilterLoaded"
                       [options]="ConfigurationPaging" [group]="ConfigurationForm" #ConfigurationPagingViewElement>
          </BBSF-Paging>
        </div>
        <!-- End paging-->
      </div>
    </div>
  </div>





  <!-- Add Modal -->
  <ng-template #AddConfigurationModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("AddConfiguration")}}</h1>
      </div>

      <form [formGroup]="AddConfigurationForm"
            (ngSubmit)="addConfiguration()">

        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="Key" [group]="AddConfigurationForm">
            </BBSF-TextBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="Scope" (OnChange)="ChangeScopeValue($event)" [group]="AddConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="Type" (OnChange)="ChangeTypeValue($event)" [group]="AddConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="Value" *ngIf="ShowValueAndDefaultValue" [group]="AddConfigurationForm">
            </BBSF-TextBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="DefaultValue" *ngIf="ShowValueAndDefaultValue" [group]="AddConfigurationForm">
            </BBSF-TextBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-Toggleslide [options]="ValueToggel" *ngIf="ShowValueToggleAndDefaultValue" [group]="AddConfigurationForm">
            </BBSF-Toggleslide>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-Toggleslide [options]="DefaultValueToggel" *ngIf="ShowValueToggleAndDefaultValue" [group]="AddConfigurationForm">
            </BBSF-Toggleslide>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="Source" *ngIf="ShowDropDownSource" (OnChange)="ChangeSource($event)" [group]="AddConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="SourcePath" *ngIf="ShowSourcePath" [group]="AddConfigurationForm">
            </BBSF-TextBox>
          </div>
        </div>
        <div class="row" *ngIf="ShowSourceFunctionPath">
          <div class="col-md-12">
            <BBSF-TextBox [options]="FunctionSourcePath" [group]="AddConfigurationForm">
            </BBSF-TextBox>
          </div>
          <div class="col-md-12">
            <button type="button" (click)="SearchForFunction(true)">
              <span class="float-right"><i class="fa fa-search"></i></span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="SourceFuncValue" *ngIf="ShowSourceFunctionData" [group]="AddConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="SourceFuncDefaultValue" *ngIf="ShowSourceFunctionData" [group]="AddConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="Lookup" *ngIf="ShowLookupList" (OnChange)="ChangeLookup($event)" [group]="AddConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="LookupValue" *ngIf="ShowLookupItemsList" [group]="AddConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="LookupDefaultValue" *ngIf="ShowLookupItemsList" [group]="AddConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="PermissionSet" *ngIf="ShowPermissionList" [group]="AddConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="User" *ngIf="ShowUsersList" [group]="AddConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="text-center pt-7">
          <button #CloseConfigurationModal id="CloseConfigurationModal" type="button" class="btn btn-light me-3 btn-sm"
                  (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>
    </div>
  </ng-template>
  <!--Edit Modal-->
  <ng-template #EditConfigurationModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Edit")}} {{utilityService.getResourceValue("Configuration")}}</h1>
      </div>
      <form [formGroup]="EditConfigurationForm" (ngSubmit)="editConfiguration()">
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="EditKey" [group]="EditConfigurationForm">
            </BBSF-TextBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="EditTextValue" *ngIf="ShowValueAndDefaultValue" [group]="EditConfigurationForm">
            </BBSF-TextBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="EditTextDefaultValue" *ngIf="ShowValueAndDefaultValue" [group]="EditConfigurationForm">
            </BBSF-TextBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-Toggleslide [options]="EditValueToggele" *ngIf="ShowValueToggleAndDefaultValue" [group]="EditConfigurationForm">
            </BBSF-Toggleslide>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-Toggleslide [options]="EditDefaultValueToggele" *ngIf="ShowValueToggleAndDefaultValue" [group]="EditConfigurationForm">
            </BBSF-Toggleslide>
          </div>
        </div>
        <div class="row" *ngIf="ShowSourceFunctionPath">
          <div class="col-md-12">
            <BBSF-TextBox [options]="EditFunctionSourcePath" [group]="EditConfigurationForm">
            </BBSF-TextBox>
          </div>
          <div class="col-md-12">
            <button type="button" (click)="SearchForFunction(false)">
              <span class="float-right"><i class="fa fa-search"></i></span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditSourceFuncValue" *ngIf="ShowSourceFunctionPath" [group]="EditConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditSourceFuncDefaultValue" *ngIf="ShowSourceFunctionPath" [group]="EditConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditLookup" *ngIf="ShowLookupList" (OnChange)="ChangeEditLookup($event)" [group]="EditConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditLookupValue" *ngIf="ShowLookupItemsList" [group]="EditConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditLookupDefaultValue" *ngIf="ShowLookupItemsList" [group]="EditConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditPermissionSet" *ngIf="ShowPermissionList" [group]="EditConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditUser" *ngIf="ShowUsersList" [group]="EditConfigurationForm">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="text-center pt-7">
          <button #CloseEditConfigurationModal id="CloseEditConfigurationModal" type="button"
                  class="btn btn-light btn-sm  me-3" data-dismiss="modal" (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>
    </div>
  </ng-template>

  <!--deleted Modal-->
  <ng-template #deleteConfigurationModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Delete")}} {{utilityService.getResourceValue("Configuration")}}</h1>
      </div>
      <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-6">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>
    
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
             {{utilityService.getResourceValue("Delete_Question")}}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseDeleteConfigurationModal id="CloseDeleteConfigurationModal" type="button"
               class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="button" (click)="deleteConfiguration()"
                class="btn btn-light-danger btn-sm ">
          {{utilityService.getResourceValue("Delete")}}
        </button>
      </div>
    </div>
  </ng-template>

